// ../tokens/dist/index.js
var colors = (
  /** @type {const} */
  {
    "brand.deep-space-blue": "#0a111d",
    "brand.cosmic-green.5": "#14B8810d",
    "brand.cosmic-green.10": "#14B8811a",
    "brand.cosmic-green.20": "#14B88133",
    "brand.cosmic-green.50": "#14B88180",
    "brand.cosmic-green.70": "#14B881b3",
    "brand.cosmic-green.default": "#14B881",
    "brand.cosmic-green.light": "#5ACDA7",
    "brand.cosmic-green.dark": "#0E815A",
    "brand.cosmic-green.light-20": "#5ACDA733",
    "brand.nebula-blue.5": "#2D73DB0d",
    "brand.nebula-blue.10": "#2D73DB1a",
    "brand.nebula-blue.20": "#2D73DB33",
    "brand.nebula-blue.30": "#2D73DB4d",
    "brand.nebula-blue.60": "#2D73DB99",
    "brand.nebula-blue.default": "#2D73DB",
    "brand.nebula-blue.light": "#7cc1e9",
    "brand.nebula-blue.dark": "#1a6b98",
    "neutral.lunar-silver.30": "#e6e9f04d",
    "neutral.lunar-silver.60": "#e6e9f099",
    "neutral.lunar-silver.85": "#e6e9f0d9",
    "neutral.lunar-silver.default": "#e6e9f0",
    "neutral.asteroid-gray.10": "#8282821a",
    "neutral.asteroid-gray.50": "#82828280",
    "neutral.asteroid-gray.default": "#828282",
    "neutral.meteor-gray.10": "#3333331a",
    "neutral.meteor-gray.30": "#3333334d",
    "neutral.meteor-gray.50": "#33333380",
    "neutral.meteor-gray.default": "#333333",
    "neutral.galaxy-gray": "#4f4f4f",
    "neutral.comet-white": "#ffffff",
    "neutral.dark-matter": "#050a14",
    "surface.midnight-ledger": "#0b121e",
    "surface.deep-tide": "#0e1725",
    "surface.border-default": "#101c2d",
    "surface.cosmic-green-variant": "#191f41",
    "feedback.stellar-green.10": "#27ae601a",
    "feedback.stellar-green.default": "#27ae60",
    "feedback.solar-red.10": "#eb57571a",
    "feedback.solar-red.default": "#eb5757",
    "feedback.orbit-orange.10": "#f2994a1a",
    "feedback.orbit-orange.default": "#f2994a",
    "metrics.galaxy-score": "#ff6b6b",
    "metrics.alt-rank": "#fdb827",
    "metrics.topic-rank": "#8d6e63",
    "metrics.creators": "#6d98f2",
    "metrics.engagements": "#ffa07a",
    "metrics.category-rank": "#8d6e63",
    "metrics.sentiment": "#ffd54f",
    "metrics.social-dominance": "#ff8a65",
    "metrics.market-cap": "#81c784",
    "metrics.mc-fdv": "#4bfefe",
    "metrics.market-dominance": "#4e8098",
    "metrics.volume-24h": "#d97cf0",
    "metrics.volatility": "#a1887f",
    "metrics.circulating-supply": "#9575cd",
    "metrics.mentions": "#68bac8",
    "metrics.price-up": "#00b892",
    "metrics.price-down": "#f6506c",
    "metrics.followers": "#ba68c8",
    "metrics.correlation": "#7C5CFF",
    "chart.1": "#ff6b6b",
    "chart.2": "#ffe66d",
    "chart.3": "#a8e6cf",
    "chart.4": "#ff8b94",
    "chart.5": "#95e1d3",
    "chart.6": "#ffa07a",
    "chart.7": "#87ceeb",
    "chart.8": "#dda0dd",
    "chart.9": "#98d8c8",
    "chart.10": "#ff69b4",
    "chart.11": "#7fffd4",
    "chart.12": "#ffd700",
    "chart.13": "#ff4500",
    "chart.14": "#9370db",
    "chart.15": "#00fa9a",
    "chart.16": "#ff1493",
    "chart.17": "#40e0d0",
    "chart.18": "#4ecdc4",
    "chart.19": "#ffaf00",
    "chart.20": "#00ced1",
    "gradient.cosmic": "linear-gradient(225deg, #14B881 0%, #2D73DB 100%)",
    "gradient.nebula": "linear-gradient(0deg, #0a111d 0%, #1f2a3a 100%)"
  }
);
var spacing = (
  /** @type {const} */
  {
    "product.4": 4,
    "product.8": 8,
    "product.12": 12,
    "product.16": 16,
    "product.24": 24,
    "product.32": 32,
    "product.48": 48,
    "product.64": 64,
    "product.80": 80,
    "product.96": 96,
    "product.none": 0,
    "marketing.xs": 10,
    "marketing.sm": 14,
    "marketing.md": 20,
    "marketing.lg": 24,
    "marketing.xl": 40,
    "marketing.2xl": 60,
    "marketing.3xl": 80,
    "marketing.4xl": 120
  }
);
var radius = (
  /** @type {const} */
  {
    "none": 0,
    "sm": 4,
    "md": 8,
    "lg": 12,
    "xl": 16,
    "2xl": 24,
    "full": 9999
  }
);
var typography = (
  /** @type {const} */
  {
    "font-family.display": "Butler",
    "font-family.body": "Plus Jakarta Sans",
    "font-family.mono": "Roboto Mono",
    "font-weight.light": "300",
    "font-weight.regular": "400",
    "font-weight.medium": "500",
    "font-weight.semibold": "600",
    "font-weight.bold": "700",
    "font-size.xs": 10,
    "font-size.sm": 12,
    "font-size.md": 14,
    "font-size.lg": 16,
    "font-size.xl": 18,
    "font-size.2xl": 20,
    "font-size.3xl": 24,
    "font-size.4xl": 32,
    "font-size.5xl": 36,
    "font-size.display": 48,
    "font-size.display-xl": 96,
    "font-size.display-2xl": 150,
    "line-height.xs": 12,
    "line-height.sm": 16,
    "line-height.md": 20,
    "line-height.lg": 24,
    "line-height.xl": 28,
    "line-height.2xl": 32,
    "line-height.3xl": 40,
    "line-height.4xl": 48,
    "line-height.display": 56,
    "letter-spacing.tighter": -4,
    "letter-spacing.tight": -1,
    "letter-spacing.normal": 0,
    "letter-spacing.wide": 1
  }
);
var breakpoints = (
  /** @type {const} */
  {
    "product.sm": 640,
    "product.md": 768,
    "product.lg": 1024,
    "product.xl": 1280,
    "product.2xl": 1536,
    "marketing.sm": 810,
    "marketing.md": 1200,
    "marketing.lg": 1680
  }
);
var zIndex = (
  /** @type {const} */
  {
    "hide": -1,
    "base": 0,
    "dropdown": 10,
    "sticky": 20,
    "overlay": 30,
    "modal": 40,
    "popover": 50,
    "toast": 60,
    "tooltip": 70
  }
);
var motion = (
  /** @type {const} */
  {
    "duration.instant": 0,
    "duration.fast": 100,
    "duration.normal": 200,
    "duration.slow": 300,
    "duration.slower": 500,
    "easing.ease-in": "cubic-bezier(0.4, 0, 1, 1)",
    "easing.ease-out": "cubic-bezier(0, 0, 0.2, 1)",
    "easing.ease-in-out": "cubic-bezier(0.4, 0, 0.2, 1)",
    "easing.spring": "cubic-bezier(0.34, 1.56, 0.64, 1)",
    "easing.linear": "linear"
  }
);
var borderWidth = (
  /** @type {const} */
  {
    "none": 0,
    "thin": 1,
    "medium": 2,
    "thick": 3
  }
);
var opacity = (
  /** @type {const} */
  {
    "none": 0,
    "subtle": 0.05,
    "light": 0.1,
    "medium": 0.3,
    "heavy": 0.6,
    "opaque": 0.8,
    "full": 1
  }
);
var semanticDark = (
  /** @type {const} */
  {
    "text.primary": "#e6e9f0",
    "text.primary-alt": "#e6e9f0d9",
    "text.secondary": "#828282",
    "text.tertiary": "#333333",
    "text.disabled": "#333333",
    "text.inverse": "#0a111d",
    "text.link": "#2D73DB",
    "text.success": "#27ae60",
    "text.error": "#eb5757",
    "text.warning": "#f2994a",
    "background.primary": "#0a111d",
    "background.secondary": "#050a14",
    "background.tertiary": "#0b121e",
    "background.inverse": "#ffffff",
    "background.brand": "#14B88133",
    "background.accent": "#2D73DB4d",
    "background.success": "#27ae601a",
    "background.error": "#eb57571a",
    "background.warning": "#f2994a1a",
    "background.disabled": "#3333331a",
    "background.hover": "#191f41",
    "background.selected": "#14B88133",
    "background.input": "#050a14",
    "background.card": "#0e1725",
    "background.panel": "#0b121e",
    "background.overlay": "#050a14cc",
    "background-button.primary": "#14B881",
    "background-button.primary-hover": "#5ACDA7",
    "background-button.transparent": "#14B88133",
    "background-button.transparent-hover": "#5ACDA733",
    "background-button.disabled": "#3333331a",
    "border.default": "#101c2d",
    "border.strong": "#828282",
    "border.brand": "#14B881",
    "border.accent": "#2D73DB",
    "border.success": "#27ae60",
    "border.error": "#eb5757",
    "border.warning": "#f2994a",
    "border.disabled": "#33333380",
    "border.focus": "#14B881",
    "border.hover": "#14B881b3",
    "action.primary": "#14B881",
    "action.primary-hover": "#5ACDA7",
    "action.primary-active": "#0E815A",
    "action.primary-disabled": "#14B88180",
    "action.secondary": "#2D73DB",
    "action.secondary-hover": "#7cc1e9",
    "action.secondary-active": "#1a6b98",
    "action.secondary-disabled": "#2D73DB99",
    "action.tertiary": "#e6e9f0",
    "action.destructive": "#eb5757",
    "state.success": "#27ae60",
    "state.error": "#eb5757",
    "state.warning": "#f2994a",
    "state.info": "#2D73DB",
    "state.new": "#14B881",
    "state.active": "#14B881",
    "state.inactive": "#828282"
  }
);
var semanticLight = (
  /** @type {const} */
  {
    "text.primary": "#0a111d",
    "text.primary-alt": "#0a111d",
    "text.secondary": "#4f4f4f",
    "text.tertiary": "#828282",
    "text.disabled": "#0a111d",
    "text.inverse": "#e6e9f0",
    "text.link": "#14B881",
    "text.success": "#27ae60",
    "text.error": "#eb5757",
    "text.warning": "#f2994a",
    "background.primary": "#ffffff",
    "background.secondary": "#e6e9f04d",
    "background.tertiary": "#e6e9f099",
    "background.inverse": "#0a111d",
    "background.brand": "#14B88133",
    "background.accent": "#2D73DB4d",
    "background.success": "#27ae601a",
    "background.error": "#eb57571a",
    "background.warning": "#f2994a1a",
    "background.disabled": "#8282821a",
    "background.hover": "#14B8810d",
    "background.selected": "#14B8810d",
    "background.input": "#050a14",
    "background.card": "#e6e9f099",
    "background.panel": "#e6e9f099",
    "background.overlay": "#0a111d99",
    "border.default": "#e6e9f0",
    "border.strong": "#4f4f4f",
    "border.brand": "#14B881",
    "border.accent": "#2D73DB",
    "border.success": "#27ae60",
    "border.error": "#eb5757",
    "border.warning": "#f2994a",
    "border.disabled": "#82828280",
    "border.focus": "#14B881",
    "border.hover": "#14B88180",
    "background-button.primary": "#14B881",
    "background-button.primary-hover": "#0E815A",
    "background-button.transparent": "#14B8811a",
    "background-button.transparent-hover": "#14B88133",
    "background-button.disabled": "#8282821a",
    "action.primary": "#14B881",
    "action.primary-hover": "#0E815A",
    "action.primary-active": "#0E815A",
    "action.primary-disabled": "#14B88180",
    "action.secondary": "#2D73DB",
    "action.secondary-hover": "#1a6b98",
    "action.secondary-active": "#1a6b98",
    "action.secondary-disabled": "#2D73DB99",
    "action.tertiary": "#0a111d",
    "action.destructive": "#eb5757",
    "state.success": "#27ae60",
    "state.error": "#eb5757",
    "state.warning": "#f2994a",
    "state.info": "#2D73DB",
    "state.new": "#14B881",
    "state.active": "#14B881",
    "state.inactive": "#4f4f4f"
  }
);
var typoDesktop = (
  /** @type {const} */
  {
    "display.font-family": "Butler",
    "display.font-size": 48,
    "display.line-height": 56,
    "display.font-weight": "600",
    "display.letter-spacing": -4,
    "h1.font-family": "Butler",
    "h1.font-size": 36,
    "h1.line-height": 40,
    "h1.font-weight": "600",
    "h1.letter-spacing": -1,
    "h2.font-family": "Plus Jakarta Sans",
    "h2.font-size": 32,
    "h2.line-height": 32,
    "h2.font-weight": "400",
    "h2.letter-spacing": -1,
    "h3.font-family": "Plus Jakarta Sans",
    "h3.font-size": 20,
    "h3.line-height": 28,
    "h3.font-weight": "500",
    "h3.letter-spacing": -1,
    "h4.font-family": "Plus Jakarta Sans",
    "h4.font-size": 18,
    "h4.line-height": 24,
    "h4.font-weight": "500",
    "h4.letter-spacing": -1,
    "body-large.font-family": "Plus Jakarta Sans",
    "body-large.font-size": 16,
    "body-large.line-height": 28,
    "body-large.font-weight": "400",
    "body-large.letter-spacing": 0,
    "body.font-family": "Plus Jakarta Sans",
    "body.font-size": 14,
    "body.line-height": 20,
    "body.font-weight": "400",
    "body.letter-spacing": 0,
    "caption.font-family": "Plus Jakarta Sans",
    "caption.font-size": 12,
    "caption.line-height": 16,
    "caption.font-weight": "400",
    "caption.letter-spacing": 0,
    "small.font-family": "Plus Jakarta Sans",
    "small.font-size": 12,
    "small.line-height": 14,
    "small.font-weight": "400",
    "small.letter-spacing": 0,
    "xsmall.font-family": "Plus Jakarta Sans",
    "xsmall.font-size": 10,
    "xsmall.line-height": 12,
    "xsmall.font-weight": "400",
    "xsmall.letter-spacing": 0,
    "code.font-family": "Roboto Mono",
    "code.font-size": 14,
    "code.line-height": 18,
    "code.font-weight": "400",
    "code.letter-spacing": 0,
    "label.font-family": "Plus Jakarta Sans",
    "label.font-size": 12,
    "label.line-height": 16,
    "label.font-weight": "500",
    "label.letter-spacing": 0,
    "overline.font-family": "Plus Jakarta Sans",
    "overline.font-size": 10,
    "overline.line-height": 12,
    "overline.font-weight": "600",
    "overline.letter-spacing": 1,
    "metric.font-family": "Butler",
    "metric.font-size": 32,
    "metric.line-height": 40,
    "metric.font-weight": "300",
    "metric.letter-spacing": -1,
    "metric-small.font-family": "Roboto Mono",
    "metric-small.font-size": 14,
    "metric-small.line-height": 20,
    "metric-small.font-weight": "500",
    "metric-small.letter-spacing": 0
  }
);
var typoTablet = (
  /** @type {const} */
  {
    "display.font-size": 40,
    "display.line-height": 48,
    "h1.font-size": 28,
    "h1.line-height": 34,
    "h2.font-size": 24,
    "h2.line-height": 28,
    "metric.font-size": 28,
    "metric.line-height": 32
  }
);
var typoMobile = (
  /** @type {const} */
  {
    "display.font-size": 32,
    "display.line-height": 40,
    "h1.font-size": 24,
    "h1.line-height": 28,
    "h2.font-size": 20,
    "h2.line-height": 24,
    "metric.font-size": 24,
    "metric.line-height": 28
  }
);
var layout = (
  /** @type {const} */
  {
    "product.max-width": 1440,
    "product.header-height.mobile": 48,
    "product.header-height.desktop": 72,
    "product.bottom-menu-height": 60,
    "product.sidebar-width.collapsed": 64,
    "product.sidebar-width.expanded": 240,
    "product.content-padding.mobile": 16,
    "product.content-padding.tablet": 24,
    "product.content-padding.desktop": 32,
    "marketing.max-width": 1280,
    "marketing.nav-height": 112,
    "marketing.section-padding": 120,
    "marketing.section-gap": 56,
    "marketing.card-gap": 24,
    "marketing.card-padding": 60,
    "marketing.content-padding.mobile": 20,
    "marketing.content-padding.tablet": 40,
    "marketing.content-padding.desktop": 112
  }
);
var focus = (
  /** @type {const} */
  {
    "ring-width": 2,
    "ring-offset": 2,
    "ring-color": "#14B881",
    "ring-color-error": "#eb5757",
    "ring-style": "solid"
  }
);
var marketingColorDark = (
  /** @type {const} */
  {
    "canvas": "#0b121e",
    "canvas-rgb": "11, 18, 30",
    "canvas-deep": "#050A14",
    "card": "#0E1120",
    "card-rgb": "14, 17, 32",
    "card-highlight": "#0e1725",
    "footer": "#060912",
    "surface": "#1A1D2E",
    "surface-navy": "#191F41",
    "surface-dark": "#0b121e",
    "surface-accent": "#182A43",
    "text-heading": "#FFFFFF",
    "text-body": "#A0A5B8",
    "text-muted": "#6B7090",
    "text-subtle": "#4A4E66",
    "text-dim": "#3A3E56",
    "text-light": "#E6E9F0",
    "text-disabled": "#828282",
    "border": "#1A1D2E",
    "border-subtle": "rgba(130,130,130,0.1)",
    "surface-hover": "#1A1D2E80",
    "dot-inactive": "#6B709044",
    "border-faint": "#1A1D2E60",
    "border-fainter": "#1A1D2E40",
    "purple-tint": "#14B88112",
    "cyan-tint": "#6EA6F818",
    "green-tint": "#22C55E18",
    "amber-tint": "#F59E0B12",
    "purple-glow": "rgba(90, 205, 167,0.27)",
    "purple-glow-strong": "rgba(90, 205, 167,0.53)",
    "gradient-purple-cyan": "linear-gradient(90deg, #14B881, #6EA6F8)",
    "hero-radial": "radial-gradient(ellipse at center, #0E2A1A 0%, #0D0F1A 50%, #0A111D 100%)"
  }
);
var marketingColorLight = (
  /** @type {const} */
  {
    "canvas": "#F6F8FB",
    "canvas-rgb": "246, 248, 251",
    "canvas-deep": "#EAEEF4",
    "card": "#FFFFFF",
    "card-rgb": "255, 255, 255",
    "card-highlight": "#EEF2F9",
    "footer": "#EFF2F7",
    "surface": "#FFFFFF",
    "surface-navy": "#ECE9F7",
    "surface-dark": "#F1F4F9",
    "surface-accent": "#E7EEF8",
    "text-heading": "#0B1220",
    "text-body": "#4A5168",
    "text-muted": "#5B6178",
    "text-subtle": "#858BA2",
    "text-dim": "#A6ABC0",
    "text-light": "#1A1F2E",
    "text-disabled": "#9CA0AD",
    "border": "#E1E5EE",
    "border-subtle": "rgba(20, 28, 46, 0.08)",
    "surface-hover": "#EEF2F9",
    "dot-inactive": "#5B617844",
    "border-faint": "#D7DCE6",
    "border-fainter": "#E8EBF1",
    "purple-tint": "#14B88114",
    "cyan-tint": "#2C68D420",
    "green-tint": "#18A24820",
    "amber-tint": "#D9870018",
    "purple-glow": "rgba(90, 205, 167, 0.22)",
    "purple-glow-strong": "rgba(90, 205, 167, 0.38)",
    "gradient-purple-cyan": "linear-gradient(90deg, #14B881, #2C68D4)",
    "hero-radial": "radial-gradient(ellipse at center, #E8FBEE 0%, #F2F5FA 50%, #F6F8FB 100%)"
  }
);
var marketingRadius = (
  /** @type {const} */
  {
    "xs": 6,
    "sm": 8,
    "md": 10,
    "lg": 12,
    "xl": 16,
    "2xl": 20,
    "full": 9999
  }
);
var marketingShadow = (
  /** @type {const} */
  {
    "purpleGlow": "0 0 40px rgba(90, 205, 167,0.27)",
    "purpleGlowLg": "0 0 48px rgba(90, 205, 167,0.25)",
    "purpleDot": "0 0 8px rgba(90, 205, 167,0.53)",
    "card": "0 16px 40px rgba(0,0,0,0.35)",
    "dropdown": "0 25px 50px rgba(0,0,0,0.5)",
    "enterpriseCard": "0 4px 6px rgba(0,0,0,0.1), 0 10px 30px rgba(0,0,0,0.25), 0 0 60px rgba(20, 184, 129,0.08)",
    "cardInner": "inset 0 1px 0 rgba(255,255,255,0.04)"
  }
);
var marketing = {
  color: { dark: marketingColorDark, light: marketingColorLight },
  radius: marketingRadius,
  shadow: marketingShadow
};

// src/tokens/colors.ts
var mkt = marketing.color.dark;
var brand = {
  purple: colors["brand.cosmic-green.default"],
  purpleHover: colors["brand.cosmic-green.light"],
  // NOTE (DEV-11124): these brand accent primitives are NOT yet in Storm — they
  // are shared brand constants, not marketing-surface tokens. Left literal until
  // a Storm `brand` primitive namespace exists (follow-up). exact-match-only.
  purpleLight: "#B8E8C0",
  cyan: "#6EA6F8",
  green: "#22C55E",
  amber: "#F59E0B",
  teal: "#13F3C9",
  white: colors["neutral.comet-white"],
  black: "#000000"
};
var marketing2 = {
  /** Main page background */
  canvas: `var(--mkt-canvas, ${mkt["canvas"]})`,
  /** Deep canvas (Framer --token) */
  canvasDeep: `var(--mkt-canvas-deep, ${mkt["canvas-deep"]})`,
  /** Card/panel background */
  card: `var(--mkt-card, ${mkt["card"]})`,
  /** Highlighted card or hover surface */
  cardHighlight: `var(--mkt-card-highlight, ${mkt["card-highlight"]})`,
  /** Footer background */
  footer: `var(--mkt-footer, ${mkt["footer"]})`,
  /** Nav/card surface */
  surface: `var(--mkt-surface, ${mkt["surface"]})`,
  /** Dark navy surface (Framer sections) */
  surfaceNavy: `var(--mkt-surface-navy, ${mkt["surface-navy"]})`,
  /** Mid-dark surface (Framer card bg alt) */
  surfaceDark: `var(--mkt-surface-dark, ${mkt["surface-dark"]})`,
  /** Nav/card border accent (Framer --token) */
  surfaceAccent: `var(--mkt-surface-accent, ${mkt["surface-accent"]})`,
  /** Text hierarchy */
  textHeading: `var(--mkt-text-heading, ${mkt["text-heading"]})`,
  textBody: `var(--mkt-text-body, ${mkt["text-body"]})`,
  textMuted: `var(--mkt-text-muted, ${mkt["text-muted"]})`,
  textSubtle: `var(--mkt-text-subtle, ${mkt["text-subtle"]})`,
  textDim: `var(--mkt-text-dim, ${mkt["text-dim"]})`,
  /** Light text on dark sections (Framer) */
  textLight: `var(--mkt-text-light, ${mkt["text-light"]})`,
  /** Neutral placeholder / disabled (Framer) */
  textDisabled: `var(--mkt-text-disabled, ${mkt["text-disabled"]})`,
  /** Borders */
  border: `var(--mkt-border, ${mkt["border"]})`,
  borderSubtle: `var(--mkt-border-subtle, ${mkt["border-subtle"]})`,
  /** Pre-composed translucent variants. These exist as dedicated tokens because
   *  they were previously built via `${token}NN` string interpolation, which is
   *  invalid once the base token resolves to a `var(...)`. */
  /** surface @ 50% — Button secondary hover fill */
  surfaceHover: `var(--mkt-surface-hover, ${mkt["surface-hover"]})`,
  /** textMuted @ ~27% — inactive pager dots */
  dotInactive: `var(--mkt-dot-inactive, ${mkt["dot-inactive"]})`,
  /** border @ ~38% */
  borderFaint: `var(--mkt-border-faint, ${mkt["border-faint"]})`,
  /** border @ ~25% */
  borderFainter: `var(--mkt-border-fainter, ${mkt["border-fainter"]})`,
  /** Accent tints (for badge/icon backgrounds) */
  purpleTint: `var(--mkt-purple-tint, ${mkt["purple-tint"]})`,
  cyanTint: `var(--mkt-cyan-tint, ${mkt["cyan-tint"]})`,
  greenTint: `var(--mkt-green-tint, ${mkt["green-tint"]})`,
  amberTint: `var(--mkt-amber-tint, ${mkt["amber-tint"]})`,
  /** Purple glow (for CTA buttons) */
  purpleGlow: `var(--mkt-purple-glow, ${mkt["purple-glow"]})`,
  purpleGlowStrong: `var(--mkt-purple-glow-strong, ${mkt["purple-glow-strong"]})`,
  /** Gradients */
  gradientPurpleToCyan: `var(--mkt-gradient-purple-cyan, ${mkt["gradient-purple-cyan"]})`,
  heroRadial: `var(--mkt-hero-radial, ${mkt["hero-radial"]})`
};
var product = {
  // ── Primitives (from Storm) ───────────────────────────────────────────────
  /** Deep Space Blue — primary background */
  canvas: colors["brand.deep-space-blue"],
  /** Dark Matter — secondary background, cards */
  canvasDeep: colors["neutral.dark-matter"],
  /** Lunar Silver — light text */
  lunarSilver: colors["neutral.lunar-silver.default"],
  /** Cosmic Purple — primary accent */
  cosmicPurple: colors["brand.cosmic-green.default"],
  /** Nebula Blue — secondary accent */
  nebulaBlue: colors["brand.nebula-blue.default"],
  /** Stellar Green — success */
  stellarGreen: colors["feedback.stellar-green.default"],
  /** Solar Red — error, destructive */
  solarRed: colors["feedback.solar-red.default"],
  /** Orbit Orange — warning */
  orbitOrange: colors["feedback.orbit-orange.default"],
  /** Galaxy Gray */
  galaxyGray: colors["neutral.galaxy-gray"],
  /** Asteroid Gray — secondary text */
  asteroidGray: colors["neutral.asteroid-gray.default"],
  /** Meteor Gray — borders, disabled */
  meteorGray: colors["neutral.meteor-gray.default"],
  /** Comet White */
  cometWhite: colors["neutral.comet-white"],
  // ── Semantic (from Storm dark theme) ──────────────────────────────────────
  /** Text primary */
  textBody: semanticDark["text.primary"],
  /** Text secondary / helper */
  textSecondary: semanticDark["text.secondary"],
  /** Text accent */
  textAccent: semanticDark["action.primary"],
  /** Background primary */
  bgPrimary: semanticDark["background.primary"],
  /** Background secondary (cards) */
  bgSecondary: semanticDark["background.secondary"],
  /** Accent primary */
  primary: semanticDark["action.primary"],
  /** Accent primary hover */
  primaryHover: semanticDark["action.primary-hover"],
  /** Accent secondary */
  secondary: semanticDark["action.secondary"],
  /** Status colors */
  success: semanticDark["state.success"],
  error: semanticDark["state.error"],
  warning: semanticDark["state.warning"],
  /** Price / change */
  changeGreen: colors["metrics.price-up"],
  changeRed: colors["metrics.price-down"],
  /** Borders */
  border: colors["neutral.meteor-gray.default"],
  /** Disabled bg (10% of meteor gray) */
  disabled: colors["neutral.meteor-gray.10"],
  /** Disabled text */
  disabledText: colors["neutral.meteor-gray.default"],
  // ── Gradients (from Storm) ────────────────────────────────────────────────
  /** Nebula gradient: Deep Space Blue → #1F2A3A */
  gradientNebula: colors["gradient.nebula"],
  /** Cosmic gradient: Cosmic Purple → Nebula Blue */
  gradientCosmic: colors["gradient.cosmic"],
  // ── Metrics (from Storm) ──────────────────────────────────────────────────
  metricGalaxyScore: colors["metrics.galaxy-score"],
  metricAltRank: colors["metrics.alt-rank"],
  metricTopicRank: colors["metrics.topic-rank"],
  metricCreators: colors["metrics.creators"],
  metricEngagements: colors["metrics.engagements"],
  metricCategoryRank: colors["metrics.category-rank"],
  metricSentiment: colors["metrics.sentiment"],
  metricSocialDominance: colors["metrics.social-dominance"],
  metricMarketCap: colors["metrics.market-cap"],
  metricMcFdv: colors["metrics.mc-fdv"],
  metricMarketDominance: colors["metrics.market-dominance"],
  metric24hVolume: colors["metrics.volume-24h"],
  metricVolatility: colors["metrics.volatility"],
  metricCirculatingSupply: colors["metrics.circulating-supply"],
  metricMentions: colors["metrics.mentions"],
  metricFollowers: colors["metrics.followers"],
  // ── Button specs (from Storm semantic) ────────────────────────────────────
  /** Secondary button fill (purple at 20%) */
  buttonSecondaryBg: semanticDark["background-button.transparent"],
  /** Secondary button hover fill */
  buttonSecondaryHoverBg: semanticDark["background-button.transparent-hover"],
  /** Focus ring color */
  buttonFocusRing: semanticDark["border.focus"]
};
var colors2 = { brand, marketing: marketing2, product };

// src/tokens/typography.ts
var fonts = {
  marketing: {
    /** Primary sans-serif for body and headings */
    sans: "Plus Jakarta Sans",
    /** Display serif for hero lines and section headings */
    display: "Butler",
    /** Fallback stack */
    sansFallback: "Plus Jakarta Sans, system-ui, -apple-system, sans-serif",
    displayFallback: "Butler, Georgia, serif"
  },
  product: {
    /** Body text font (Storm: Plus Jakarta Sans) */
    body: typography["font-family.body"],
    /** Display font (Storm: Butler) */
    display: typography["font-family.display"],
    /** Monospace for code blocks and metrics (Storm: Roboto Mono) */
    mono: typography["font-family.mono"],
    /** Fallback stacks */
    bodyFallback: `${typography["font-family.body"]}, system-ui, -apple-system, sans-serif`,
    displayFallback: `${typography["font-family.display"]}, Georgia, serif`
  }
};
var fontWeights = {
  light: "300",
  regular: "400",
  medium: "500",
  semibold: "600",
  bold: "700"
};
var marketingTypeScale = {
  /** Hero headline (72px Plus Jakarta Sans semibold or Butler light) */
  hero: {
    fontSize: 72,
    lineHeight: 1.1,
    letterSpacing: -1
  },
  /** Section heading (48px Butler) */
  h1: {
    fontSize: 48,
    lineHeight: 1.2,
    letterSpacing: -0.5
  },
  /** Large heading (56px Butler, used in final CTA) */
  display: {
    fontSize: 56,
    lineHeight: 1.15,
    letterSpacing: -0.5
  },
  /** Sub-heading (20-24px) */
  h2: {
    fontSize: 24,
    lineHeight: 1.3,
    letterSpacing: -0.25
  },
  /** Card title (18-20px Plus Jakarta Sans semibold) */
  h3: {
    fontSize: 20,
    lineHeight: 1.35,
    letterSpacing: 0
  },
  /** Feature title (18px) */
  h4: {
    fontSize: 18,
    lineHeight: 1.4,
    letterSpacing: 0
  },
  /** Body large (17px, used in section descriptions) */
  bodyLarge: {
    fontSize: 17,
    lineHeight: 1.6,
    letterSpacing: 0
  },
  /** Body default (14-15px) */
  body: {
    fontSize: 14,
    lineHeight: 1.6,
    letterSpacing: 0
  },
  /** Small text (13px) */
  small: {
    fontSize: 13,
    lineHeight: 1.5,
    letterSpacing: 0
  },
  /** Caption / label (12px) */
  caption: {
    fontSize: 12,
    lineHeight: 1.5,
    letterSpacing: 0.5
  },
  /** Metric display (36px Plus Jakarta Sans medium) */
  metric: {
    fontSize: 36,
    lineHeight: 1.2,
    letterSpacing: -0.5
  },
  /** Price display (36px Plus Jakarta Sans semibold) */
  price: {
    fontSize: 36,
    lineHeight: 1.2,
    letterSpacing: -0.5
  }
};
var body = typography["font-family.body"];
var display = typography["font-family.display"];
var mono = typography["font-family.mono"];
var productTypeScale = {
  /** 48px Butler semibold — large display headings */
  display: { fontSize: 48, fontWeight: "600", fontFamily: display, letterSpacing: -4, lineHeight: 56 },
  /** 36px Butler semibold — page titles */
  h1: { fontSize: 36, fontWeight: "600", fontFamily: display, letterSpacing: -1, lineHeight: 40 },
  /** 32px Plus Jakarta Sans regular — section headings */
  h2: { fontSize: 32, fontWeight: "400", fontFamily: body, letterSpacing: -1, lineHeight: 32 },
  /** 20px Plus Jakarta Sans medium — card titles */
  h3: { fontSize: 20, fontWeight: "500", fontFamily: body, letterSpacing: -1, lineHeight: 28 },
  /** 18px Plus Jakarta Sans medium — sub-headings */
  h4: { fontSize: 18, fontWeight: "500", fontFamily: body, letterSpacing: -1, lineHeight: 24 },
  /** 16px Plus Jakarta Sans regular — large body text */
  bodyLarge: { fontSize: 16, fontWeight: "400", fontFamily: body, letterSpacing: 0, lineHeight: 28 },
  /** 16px Plus Jakarta Sans semibold — bold large body */
  bodyLargeBold: { fontSize: 16, fontWeight: "600", fontFamily: body, letterSpacing: -1, lineHeight: 28 },
  /** 14px Plus Jakarta Sans regular — default body */
  body: { fontSize: 14, fontWeight: "400", fontFamily: body, letterSpacing: 0, lineHeight: 20 },
  /** 12px Plus Jakarta Sans regular — captions */
  caption: { fontSize: 12, fontWeight: "400", fontFamily: body, letterSpacing: 0, lineHeight: 16 },
  /** 14px Roboto Mono regular — code blocks */
  code: { fontSize: 14, fontWeight: "400", fontFamily: mono, letterSpacing: 0, lineHeight: 18 },
  /** 12px Plus Jakarta Sans regular — small text */
  small: { fontSize: 12, fontWeight: "400", fontFamily: body, letterSpacing: 0, lineHeight: 14 },
  /** 10px Plus Jakarta Sans regular — extra-small labels */
  xsmall: { fontSize: 10, fontWeight: "400", fontFamily: body, letterSpacing: 0, lineHeight: 12 },
  /** 12px Plus Jakarta Sans medium — labels */
  label: { fontSize: 12, fontWeight: "500", fontFamily: body, letterSpacing: 0, lineHeight: 16 },
  /** 10px Plus Jakarta Sans semibold — overlines */
  overline: { fontSize: 10, fontWeight: "600", fontFamily: body, letterSpacing: 1, lineHeight: 12 },
  /** 32px Butler light — metric display */
  metric: { fontSize: 32, fontWeight: "300", fontFamily: display, letterSpacing: -1, lineHeight: 40 },
  /** 14px Roboto Mono medium — small metric display */
  metricSmall: { fontSize: 14, fontWeight: "500", fontFamily: mono, letterSpacing: 0, lineHeight: 20 }
};
var typography2 = {
  fonts,
  fontWeights,
  marketingTypeScale,
  productTypeScale
};

// src/tokens/spacing.ts
var marketingSpacing = {
  xs: 10,
  sm: 14,
  md: 20,
  lg: 24,
  xl: 40,
  "2xl": 60,
  "3xl": 80,
  "4xl": 120
};
var productSpacing = {
  unit: 8,
  xs: spacing["product.4"],
  // 0.5x
  sm: spacing["product.8"],
  // 1x
  "1.5x": spacing["product.12"],
  // 1.5x
  md: spacing["product.16"],
  // 2x
  lg: spacing["product.24"],
  // 3x
  xl: spacing["product.32"],
  // 4x
  "2xl": spacing["product.48"],
  // 6x
  "3xl": spacing["product.64"],
  // 8x
  "4xl": spacing["product.80"],
  // 10x
  "5xl": spacing["product.96"]
  // 12x
};
var sectionSpacing = {
  /** Padding-top/bottom for standard sections (Framer: 120px) */
  section: 120,
  /** Gap between section badge → heading → description */
  sectionGap: 56,
  /** Gap inside card grids (uniform horizontal & vertical) */
  cardGap: 24,
  /** Internal card padding (Framer: 60px) */
  cardPadding: 60,
  /** Nav height (Framer: 112px) */
  navHeight: 112
};
var productButtonSizes = {
  lg: { height: 56, paddingX: 24, paddingY: 16, iconSize: 24, gap: 8, radius: 6 },
  md: { height: 36, paddingX: 16, paddingY: 8, iconSize: 20, gap: 8, radius: 6 },
  sm: { height: 26, paddingX: 8, paddingY: 4, iconSize: 16, gap: 8, radius: 6 }
};
var spacing2 = {
  marketing: marketingSpacing,
  product: productSpacing,
  section: sectionSpacing,
  productButtons: productButtonSizes
};

// src/tokens/radii.ts
var marketingRadii = {
  /** Framer default rounding (nav items, small cards) */
  xs: marketing.radius.xs,
  /** Subtle rounding (icons, small elements) */
  sm: marketing.radius.sm,
  /** Buttons */
  md: marketing.radius.md,
  /** Dropdown / small cards */
  lg: marketing.radius.lg,
  /** Cards */
  xl: marketing.radius.xl,
  /** Large panels / hero cards */
  "2xl": marketing.radius["2xl"],
  /** Pill / badges */
  full: marketing.radius.full
};
var productRadii = {
  none: radius.none,
  sm: radius.sm,
  md: radius.md,
  lg: radius.lg,
  xl: radius.xl,
  "2xl": radius["2xl"],
  full: radius.full
};
var radii = marketingRadii;

// src/tokens/shadows.ts
var shadows = {
  /** Purple glow for primary CTA buttons */
  purpleGlow: marketing.shadow.purpleGlow,
  /** Stronger purple glow for large CTAs */
  purpleGlowLg: marketing.shadow.purpleGlowLg,
  /** Purple dot glow (status indicator) */
  purpleDot: marketing.shadow.purpleDot,
  /** Card elevation shadow */
  card: marketing.shadow.card,
  /** Dropdown shadow */
  dropdown: marketing.shadow.dropdown,
  /** Enterprise card multi-layer shadow (Framer /enterprise page) */
  enterpriseCard: marketing.shadow.enterpriseCard,
  /** Subtle inner highlight for glass-morphism cards */
  cardInner: marketing.shadow.cardInner
};

// src/tokens/motion.ts
var durations = {
  instant: motion["duration.instant"],
  fast: motion["duration.fast"],
  normal: motion["duration.normal"],
  slow: motion["duration.slow"],
  slower: motion["duration.slower"]
};
var easings = {
  standard: motion["easing.ease-in-out"],
  easeIn: motion["easing.ease-in"],
  easeOut: motion["easing.ease-out"],
  spring: motion["easing.spring"],
  linear: motion["easing.linear"],
  /** Marketing-specific: quick ease-out for hover effects */
  hover: "ease"
};
var motion2 = { durations, easings };

// src/tokens/breakpoints.ts
var marketingBreakpoints = {
  /** Mobile (< 810px) */
  sm: 810,
  /** Tablet / small desktop (< 1200px) */
  md: 1200,
  /** Desktop (< 1680px) */
  lg: 1680
};
var productBreakpoints = {
  sm: breakpoints["product.sm"],
  md: breakpoints["product.md"],
  lg: breakpoints["product.lg"],
  xl: breakpoints["product.xl"],
  "2xl": breakpoints["product.2xl"]
};
var maxWidths = {
  /** Marketing page max-width */
  marketing: 1280,
  /** Product app max-width (from Storm layout tokens) */
  product: layout["product.max-width"]
};
var breakpoints2 = {
  marketing: marketingBreakpoints,
  product: productBreakpoints,
  maxWidths
};

export {
  colors,
  spacing,
  radius,
  typography,
  breakpoints,
  zIndex,
  motion,
  borderWidth,
  opacity,
  semanticDark,
  semanticLight,
  typoDesktop,
  typoTablet,
  typoMobile,
  layout,
  focus,
  brand,
  marketing2 as marketing,
  product,
  colors2,
  fonts,
  fontWeights,
  marketingTypeScale,
  productTypeScale,
  typography2,
  marketingSpacing,
  productSpacing,
  sectionSpacing,
  spacing2,
  marketingRadii,
  productRadii,
  radii,
  shadows,
  durations,
  easings,
  motion2,
  marketingBreakpoints,
  productBreakpoints,
  maxWidths,
  breakpoints2
};
//# sourceMappingURL=chunk-RWJTCKM5.mjs.map